module.exports = __webpack_public_path__ + "img/bg-top.1fdb58d1.png";